import { Select } from 'antd';

const { Option } = Select;

const MultiSelect = ({ options, selectedValues, onChange, placeholder }) => (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder={placeholder}
      value={selectedValues}
      onChange={onChange}
    >
      {options.map(option => (
        <Option key={option.value} value={option.value}>{option.label}</Option>
      ))}
    </Select>
  );

export default MultiSelect;